import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled(OutputText)`
	--size: var(--px-24);
	--color: var(--neutrals-700);
	--border-color: var(--neutrals-700);
	--background-color: var(--neutrals-00white);
	height: var(--size);
	width: var(--size);
	display: flex;
	justify-content: center;
	align-items: center;
	border: var(--border-width-small) solid var(--border-color);
	border-radius: var(--border-radius-small);
	color: var(--color);
	background-color: var(--background-color);
	justify-self: center;

	&.empty {
		--color: transparent;
		--border-color: transparent;
		--background-color: transparent;
	}

	&.high {
		--color: var(--neutrals-50);
		--border-color: var(--maroon-500);
		--background-color: var(--maroon-500);
	}

	&.risk:not(.empty) {
		--size: var(--px-8);
		--border-color: var(--neutrals-300);
		--background-color: var(--neutrals-300);
		border-radius: 50%;
		&.high {
			--size: var(--px-13);
			--border-color: var(--maroon-500);
			--background-color: var(--maroon-500);
		}
	}
`;
